import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ToolGuard } from '../../core/guards/tool.guard';
import { EditInfoComponent } from './edit-info.component';
import { FeatureParamsResolverService } from './services/feature-params-resolver.service';

const routes: Routes = [
  {
    path: 'info',
    canActivateChild: [ToolGuard],
    children: [
      {
        path: ':layer',
        component: EditInfoComponent,
        resolve: {
          featureParams: FeatureParamsResolverService,
        },
      },
    ],
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class EditInfoRoutingModule {}
